import { render } from "./LanguageSelectorLight.vue?vue&type=template&id=3b2b208e"
import script from "./LanguageSelectorLight.vue?vue&type=script&lang=js"
export * from "./LanguageSelectorLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__